import axios from "axios";
import { getToken, setToken, clearToken } from "./token";

const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 15000
});

http.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  return config;
});

http.interceptors.response.use(
  (res) => {
    const body = res && res.data ? res.data : null;
    // 兼容：/user/me 可能下发新 token（例如用户记录被清理后自动补建）
    if (body && body.ok && body.data && body.data.token) {
      setToken(body.data.token);
    }
    return body;
  },
  (err) => {
    const status = err && err.response && err.response.status;
    if (status === 401) {
      clearToken();
      if (location.pathname !== "/login") location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default http;

